<template>
    <recovery :onRecovery="recovery" />
</template>
<script>
import { mapActions } from 'vuex';
import Recovery from './Recovery';

export default {
    name: 'recovery-container',
    components: {
        Recovery,
    },
    methods: {
        ...mapActions('auth', ['recovery']),
    },
}
</script>



// WEBPACK FOOTER //
// RecoveryContainer.vue?76a97437